import { connect } from 'react-redux';
import {
  getAllQuote,
  getFranchise, 
  getCustomerList,
  getRoyaltyReportForViewBreakDown
} from '../../../../Action';
import ViewBreakdown from '../ViewBreakdown';

const mapStateToProps = (state) => {
  const {
    franchiseList,
    RoyaltyBreakDown,
    CommercialProposal,
  } = state;

  return {
    franchiseList,
    RoyaltyBreakDown,
    CommercialProposal
  }
}
const actionCreators = {
  getAllQuote,
  getFranchise,
  getCustomerList,
  getRoyaltyReportForViewBreakDown
}
export default (connect(mapStateToProps, actionCreators)(ViewBreakdown));